module.exports = __webpack_public_path__ + "img/deska-lita.c94f4224.jpg";